import logger from './logger';

export function formatCurrency(
	num,
	locale = 'en_US',
	showFractionDigits = false
) {
	const options = {
		style: 'currency',
		currency: locale.length && locale.indexOf('CA') > -1 ? 'CAD' : 'USD'
	};
	let currencyValue;

	if (typeof num !== 'number') {
		logger.warn(
			`formatCurrency: unexpected currency value: ${num} of type ${typeof num}`
		);
		return '';
	}

	if (showFractionDigits) {
		// two fraction digits (aka decimal places) by default
		currencyValue = num;
	} else {
		currencyValue = Math.round(num);
		options.minimumFractionDigits = 0;
	}

	return new Intl.NumberFormat(locale.replace('_', '-'), options).format(
		currencyValue
	);
}

export function formatNumber(num, locale = 'en_US') {
	if (typeof num !== 'number') {
		return '';
	}
	return new Intl.NumberFormat(locale.replace('_', '-')).format(num);
}

export function formatDate(d, locale = 'en_US', options) {
	let date;
	if (d instanceof Date) {
		date = d;
	} else if (typeof d === 'string' || Number.isInteger(d)) {
		date = new Date(d);
	}
	if (date && Number.isFinite(date.getTime())) {
		return new Intl.DateTimeFormat(
			locale.replace('_', '-'),
			options
		).format(date);
	}
	return '';
}



// WEBPACK FOOTER //
// ./~/ws-scripts/modules/intl.js